// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1i1Bh","options":"AnswerScale_options__3Np_z","selected":"AnswerScale_selected__y5kbE"};